import React from 'react'

export const RightArrowIcon: React.FC = () => {
	return (
		<svg
			id='Group_4666'
			data-name='Group 4666'
			xmlns='http://www.w3.org/2000/svg'
			width='5.967'
			height='10.157'
			className='rightarrow-icon-svg'
			viewBox='0 0 5.967 10.157'>
			<path
				id='Path_3472'
				data-name='Path 3472'
				d='M107.283,4.682l-4.52-4.52a.557.557,0,0,0-.786,0L101.644.5a.556.556,0,0,0,0,.786l3.8,3.8-3.8,3.8a.557.557,0,0,0,0,.786l.333.333a.557.557,0,0,0,.786,0l4.524-4.524a.561.561,0,0,0,0-.789Z'
				transform='translate(-101.478)'
				fill='#fff'
			/>
		</svg>
	)
}
